/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable no-empty */
import { FC, useCallback } from 'react';

import { useRouter } from 'next/router';

import { useSidebar } from '~/layouts/private/providers/sidebar';

import { useFavoritesCoins } from '~/common/providers/favoritesCoins';
import { TabMenu } from '~/common/components/TabMenu';
import { CryptoBadge } from '~/common/components/CryptoBadge';

interface ISidebarFavoritesProps {
  closeMobileSidebar?: () => void;
}
export const SidebarFavorites: FC<ISidebarFavoritesProps> = ({
  closeMobileSidebar,
}) => {
  const { collapsed } = useSidebar();
  const { favorites, variant } = useFavoritesCoins();
  const router = useRouter();

  const renderFavoiteCoinContent = useCallback(
    (id: string) => {
      const found = favorites?.find((fav) => String(fav.id) === id);
      if (!found) {
        return null;
      }

      return (
        <div style={{ cursor: 'pointer' }}>
          {collapsed ? (
            <img
              style={{ borderRadius: '50%', width: '24px', height: '24px' }}
              src={found?.image}
              alt={found?.name || 'badge'}
            />
          ) : (
            <CryptoBadge
              withoutClick={variant === 'stock'}
              variant={variant}
              withoutBorder
              id={found?.id}
              logo={found?.image}
              name={found?.name}
              onlyImage={collapsed}
              {...(variant === 'crypto' && {
                badgeStyle: { cursor: 'pointer' },
              })}
            />
          )}
        </div>
      );
    },
    [favorites, collapsed, variant]
  );

  return (
    <TabMenu.Vertical
      fullWidth
      withoutPadding
      withBorder={false}
      current=""
      options={(favorites || []).map((fav) => {
        const config = `${fav.name}_${fav.image}_${fav.id}`;

        return {
          key: String(fav.id),
          title: fav.name,
          image: fav.image,
          compact: collapsed,
          withoutHoverCursor: variant === 'stock',
          renderContent: renderFavoiteCoinContent,
          ...(variant !== 'stock' && {
            optionClick: () => {
              closeMobileSidebar?.();
              router.push(`/favorites?params=${config}`);
            },
          }),
        };
      })}
    />
  );
};
